import React, { useMemo, RefObject, FC, ReactElement } from "react"

import { ButtonProps } from "../../button"
import { Text } from "../../text"

import { StyledButton } from "./styles"

export type EmptyStateCTAButtonProps = Omit<ButtonProps, "variant" | "size"> & {
  ref?:
    | ((instance: HTMLButtonElement | null) => void)
    | RefObject<HTMLButtonElement>
    | null
    | undefined
}

export type EmptyStateBaseProps = {
  headline: string
  subtitle: string | ReactElement
  ctaButtonProps?: EmptyStateCTAButtonProps
}

export const EmptyStateBase: FC<EmptyStateBaseProps> = ({
  children,
  headline,
  subtitle,
  ctaButtonProps,
}) => {
  const ctaButton = useMemo(() => {
    return ctaButtonProps ? <StyledButton variant="minor" {...ctaButtonProps} /> : null
  }, [ctaButtonProps])

  return (
    <>
      {children}

      <Text.Title3 marginTop="medium">{headline}</Text.Title3>

      {typeof subtitle === "string" ? (
        <Text.Regular marginBottom="none">{subtitle}</Text.Regular>
      ) : (
        subtitle
      )}

      {ctaButton}
    </>
  )
}
